<div
    id="app-navigation"
    [class.expanded]="!isSidebarCollapsed()"
    [attr.aria-expanded]="!isSidebarCollapsed()"
    (wheel)="hideOverlays()">
    @for (navList of appNavigation(); let i = $index; track i) {
        <ng-container>
            <nav [id]="'app-navigation-section-' + i" class="nav-list" aria-label="Main Navigation">
                @for (navItem of navList; track navItem.id) {
                    @if (!navItem.submenu && !navItem.isHidden) {
                        @if (navItem.internalRoute) {
                            <a
                                (mouseenter)="navItemHover(navItem.id, $event)"
                                [pTooltip]="isSidebarCollapsed() ? (navItem.label | translate) : ''"
                                [routerLink]="navItem.url"
                                [routerLinkActive]="['active-link']"
                                [routerLinkActiveOptions]="{ exact: false }"
                                [id]="navItem.id + '-nav-link'"
                                class="nav-link"
                                [attr.aria-label]="'Open menu ' + navItem.label">
                                <ng-container
                                    [ngTemplateOutlet]="navLink"
                                    [ngTemplateOutletContext]="{ navItem: navItem }"></ng-container>
                            </a>
                        }

                        @if (!navItem.internalRoute) {
                            <a
                                (mouseenter)="navItemHover(navItem.id, $event)"
                                [pTooltip]="isSidebarCollapsed() ? (navItem.label | translate) : ''"
                                [href]="navItem.url"
                                [target]="'_blank'"
                                [id]="navItem.id + '-nav-link'"
                                class="nav-link"
                                [attr.aria-label]="'Open menu ' + navItem.label">
                                <ng-container
                                    [ngTemplateOutlet]="navLink"
                                    [ngTemplateOutletContext]="{ navItem: navItem }"></ng-container>
                            </a>
                        }
                    }

                    @if (navItem.submenu && !navItem.isHidden) {
                        <button
                            (click)="navItemClick(navItem)"
                            (mouseenter)="navItemHover(navItem.id, $event)"
                            [id]="navItem.id + '-nav-link'"
                            [class.active-link]="isRichMenuActive(navItem)"
                            class="nav-link">
                            <ng-container
                                [ngTemplateOutlet]="navLink"
                                [ngTemplateOutletContext]="{ navItem: navItem }"></ng-container>
                        </button>
                    }

                    <div
                        [ngClass]="navItem.expanded ? 'submenu-expanded' : 'submenu-collapsed'"
                        [attr.aria-expanded]="navItem.expanded"
                        class="submenu"
                        [id]="navItem.id + '-submenu'"
                        tabindex="-1">
                        @for (submenuItem of navItem.submenu; track submenuItem.id) {
                            @if (!submenuItem.isHidden) {
                                @if (submenuItem.internalRoute) {
                                    <a
                                        [routerLink]="submenuItem.disabled ? null : submenuItem.url"
                                        [routerLinkActive]="['active-submenu-link']"
                                        [routerLinkActiveOptions]="{ exact: false }"
                                        [id]="submenuItem.id + '-submenu-nav-link'"
                                        [tabindex]="!navItem.expanded ? '-1' : '0'"
                                        class="submenu-link"
                                        [attr.aria-label]="'Open menu ' + submenuItem.label"
                                        [class.disabled-option]="submenuItem.disabled">
                                        <div
                                            class="btn-icon-dot"
                                            [id]="submenuItem.id + '-submenu-icon'"
                                            aria-hidden="true">
                                            <span>
                                                <i class="fa-sharp fa-solid fa-circle-dot"></i>
                                            </span>
                                        </div>
                                        <span class="nav-label" [id]="submenuItem.id + '-submenu-label'">{{
                                            submenuItem.label | translate
                                        }}</span>
                                    </a>
                                }

                                @if (!submenuItem.internalRoute) {
                                    <a
                                        [href]="[submenuItem.url]"
                                        [target]="'_blank'"
                                        [id]="submenuItem.id + '-submenu-nav-link'"
                                        [tabindex]="!navItem.expanded ? '-1' : '0'"
                                        class="submenu-link"
                                        [class.external-link]="!submenuItem.internalRoute"
                                        [attr.aria-label]="'Open menu ' + submenuItem.label">
                                        <div>
                                            <div
                                                class="btn-icon-dot"
                                                [id]="submenuItem.id + '-submenu-icon'"
                                                aria-hidden="true">
                                                <span>
                                                    <i class="fa-sharp fa-solid fa-circle-dot"></i>
                                                </span>
                                            </div>
                                            <span class="nav-label" [id]="submenuItem.id + '-submenu-label'">{{
                                                submenuItem.label | translate
                                            }}</span>
                                        </div>
                                        <i class="fa-regular fa-arrow-up-right-from-square"></i>
                                    </a>
                                }
                            }
                        }
                    </div>
                }
            </nav>
        </ng-container>
    }

    <div class="extra-space" (mouseenter)="hideOverlays()"></div>
</div>

<ng-template #navLink let-navItem="navItem">
    @if (navItem.icon) {
        <div class="btn-icon" [id]="navItem.id + '-icon'" aria-hidden="true">
            <i [class]="navItem.icon"></i>
        </div>
    }
    @if (navItem.imageSvg) {
        <div class="btn-icon" [id]="navItem.id + '-icon'" aria-hidden="true">
            <img [src]="navItem.imageSvg" alt="icon" />
        </div>
    }
    <span class="nav-label" [id]="navItem.id + '-label'">{{ navItem.label | translate }}</span>

    @if (navItem.submenu) {
        <div class="expand-btn-container" aria-hidden="true">
            <button
                [id]="navItem.id + '-expand-submenu-btn'"
                aria-label="Toggle menu"
                tabindex="-1"
                pButton
                class="p-button-rounded p-button-text expand-menu-btn p-button-secondary">
                <i class="fa-light" [ngClass]="navItem.expanded ? 'fa-angle-up' : 'fa-angle-down'"></i>
            </button>
        </div>
    }
</ng-template>

<p-popover #ovStrains styleClass="popover" [style]="overlayStyleMyStrains" [focusOnShow]="true">
    <div (mouseleave)="hideOverlays()" (wheel)="hideOverlays()" class="popover">
        <div class="popover-header">
            <p>{{ 'toolbar.strains' | translate }}</p>
        </div>
        <div class="popover-body">
            @for (submenu of myStrainsSubmenu; track submenu.id) {
                <ng-container
                    [ngTemplateOutlet]="popoverSubmenu"
                    [ngTemplateOutletContext]="{ submenu: submenu }"></ng-container>
            }
        </div>
    </div>
</p-popover>

<p-popover #ovCages styleClass="popover" [style]="overlayStyleMyCages" [focusOnShow]="true">
    <div (mouseleave)="hideOverlays()" (wheel)="hideOverlays()" class="popover">
        <div class="popover-header">
            <p>{{ 'toolbar.cages' | translate }}</p>
        </div>
        <div class="popover-body">
            @for (submenu of myCagesSubmenu; track submenu.id) {
                <ng-container
                    [ngTemplateOutlet]="popoverSubmenu"
                    [ngTemplateOutletContext]="{ submenu: submenu }"></ng-container>
            }
        </div>
    </div>
</p-popover>

<p-popover #ovAdministration styleClass="popover" [style]="overlayStyleMyAdministration" [focusOnShow]="true">
    <div (mouseleave)="hideOverlays()" (wheel)="hideOverlays()" class="popover">
        <div class="popover-header">
            <p>{{ 'toolbar.administration' | translate }}</p>
        </div>
        <div class="popover-body">
            @for (submenu of myAdministrationSubmenu; track submenu.id) {
                <ng-container
                    [ngTemplateOutlet]="popoverSubmenu"
                    [ngTemplateOutletContext]="{ submenu: submenu }"></ng-container>
            }
        </div>
    </div>
</p-popover>

<ng-template #popoverSubmenu let-submenu="submenu">
    @if (!submenu.isHidden) {
        @if (!submenu.internalRoute) {
            <a [href]="submenu.url" [target]="'_blank'" [id]="submenu.id" [attr.aria-label]="'Go to ' + submenu.label">
                <div class="btn-icon-dot" [id]="submenu.id + '-submenu-icon-popover'" aria-hidden="true">
                    <span>
                        <i class="fa-sharp fa-solid fa-circle-dot"></i>
                    </span>
                </div>
                {{ submenu.label | translate }}
            </a>
        }

        @if (submenu.internalRoute) {
            <a
                [routerLink]="submenu.url"
                [id]="submenu.id"
                (click)="hideOverlays()"
                [attr.aria-label]="'Go to ' + submenu.label">
                <div class="btn-icon-dot" [id]="submenu.id + '-submenu-icon-popover'" aria-hidden="true">
                    <span>
                        <i class="fa-sharp fa-solid fa-circle-dot"></i>
                    </span>
                </div>
                {{ submenu.label | translate }}
            </a>
        }
    }
</ng-template>
